exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2zj0jFDaBjW_5VSRXC28A1 {\n  margin-bottom: 16px;\n  text-align: center;\n}\n._2zj0jFDaBjW_5VSRXC28A1 ._3zBnqSqjTHuhPr00PfnSzu {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 22px;\n  color: #727272;\n  margin: 24px 0 16px 0;\n  text-transform: uppercase;\n}\n._1tc4RBRAPDuTqEL5IZPSaf {\n  text-align: center;\n}\n._1tc4RBRAPDuTqEL5IZPSaf p {\n  margin: 0 0 24px 0;\n}\n._10dYgHrpsTHolJ9q939zCv {\n  margin: 24px 0 0 0;\n  text-align: center;\n}\n._ggH5xCNpggeMvIue7T8 {\n  color: #727272;\n  font-size: 18px;\n  margin: 0 0 16px 0;\n  font-weight: 500;\n  line-height: 22px;\n}\n", ""]);

// exports
exports.locals = {
	"join": "_2zj0jFDaBjW_5VSRXC28A1",
	"dontHaveAccount": "_3zBnqSqjTHuhPr00PfnSzu",
	"lticontainer": "_1tc4RBRAPDuTqEL5IZPSaf",
	"footer": "_10dYgHrpsTHolJ9q939zCv",
	"notStudent": "_ggH5xCNpggeMvIue7T8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-2!./node_modules/postcss-loader/lib??postcss!./node_modules/less-loader/dist/cjs.js!./src/client/Pages/Auth/Login/Login.css
// module id = 2214
// module chunks = 35